"use client";

import { createContext, useContext, useState, useEffect } from "react";

interface PanelContextValue {
  /** "" on panel subdomain, "/comercio" or "/gestion" on main domain */
  basePath: string;
}

const PanelContext = createContext<PanelContextValue>({ basePath: "" });

export function PanelProvider({
  basePath,
  children,
}: {
  basePath: string;
  children: React.ReactNode;
}) {
  return (
    <PanelContext.Provider value={{ basePath }}>{children}</PanelContext.Provider>
  );
}

export function usePanelPath() {
  return useContext(PanelContext);
}

/**
 * Returns "" on panel subdomain (clean URLs), or "/comercio" | "/gestion" on main domain.
 * SSR-safe: defaults to prefixed path, updates after mount on subdomain.
 */
export function useSubdomainBasePath(panel: "comercio" | "gestion"): string {
  const [basePath, setBasePath] = useState(`/${panel}`);
  useEffect(() => {
    const domain = process.env.NEXT_PUBLIC_DOMAIN;
    if (!domain) return;
    if (window.location.hostname === `${panel}.${domain}`) {
      setBasePath("");
    }
  }, [panel]);
  return basePath;
}
